import useTranslation from '@space-lib/hooks/useTranslation'
import CustomTextArea from '@space-shell/common/components/customTextarea'

import { MAX_SIZE } from '../constants'
import useDeleteCommunityModal from '../hooks/useDeleteCommunityModal/useDeleteCommunityModal'

const InitialExpectationStep = () => {
  const { t } = useTranslation()
  const { initialExpectationText, setInitialExpectationText } = useDeleteCommunityModal()

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInitialExpectationText(event.target.value)
  }

  return (
    <CustomTextArea
      label={t('community_survey.delete_community.initial_expectation.title')}
      name='initial-expectation-textarea'
      dataTestId='initial-expectation-textarea'
      value={initialExpectationText}
      onChange={handleChange}
      placeholder={t('community_survey.delete_community.text_area_placeholder')}
      maxSize={MAX_SIZE}
      currentSize={initialExpectationText.length}
      className='_mb-0 _text-gray-900'
    />
  )
}

export default InitialExpectationStep
